import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suspend',
  templateUrl: './suspend.component.html',
  styleUrls: ['./suspend.component.css']
})
export class SuspendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
